import * as yup from 'yup';


export const commonCollectionValidation: { [x: string]: any; } = {
  paymentMode: yup.string().required("Missing."),
  paymentAmount: yup.number().required("Missing."),
  payee: yup.string().required("Missing."),
};
export const poCollectionValidation: { [x: string]: any; } = {
  payOrderNo: yup.string().required("Missing."),
  bankCode: yup.string().required("Missing."),
  payOrderAmount: yup.number().required("Missing."),
};

export const createCollectionValidation: { [x: string]: any; } = {
  ...commonCollectionValidation,
};
export const createPOCollectionValidation: { [x: string]: any; } = {
  ...poCollectionValidation,
};

export const createCollectionValidationSchema = yup.object().shape(createCollectionValidation);
export const createPOCollectionValidationSchema = yup.object().shape(createPOCollectionValidation);

